import React from "react";
import { Reveal } from "./Reveal";

// Quiet chapter marker — no time indicators. The story is a working day, not a clock.
export const Chapter = ({ title }) => (
  <Reveal className="mb-8 flex items-center gap-3">
    <span className="h-px w-8 bg-[#EA6A43]" />
    <span className="font-body text-[11px] uppercase tracking-[0.3em] text-[#9a958c]">
      {title}
    </span>
  </Reveal>
);
